import { render, staticRenderFns } from "./AddResourceModal.vue?vue&type=template&id=49571142&scoped=true"
import script from "./AddResourceModal.vue?vue&type=script&lang=js"
export * from "./AddResourceModal.vue?vue&type=script&lang=js"
import style0 from "./AddResourceModal.vue?vue&type=style&index=0&id=49571142&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49571142",
  null
  
)

export default component.exports